import { useState, useEffect } from "react";

import { InteractionStatus, InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../authConfig";

/**
 * Custom hook to obtain a bearer token silently via MSAL.
 * The single redirect-based login is handled once at the top-level Pages component.
 */
const useFetchWithMsal = () => {
  const { instance, inProgress } = useMsal();
  // If a token is already cached start unlocked so queries don't wait unnecessarily.
  const [skip, setSkip] = useState(() => !localStorage.getItem("token"));

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    const account = instance.getActiveAccount();
    if (!account) return;

    instance
      .acquireTokenSilent({
        scopes: protectedResources.api.scopes.read,
        account,
      })
      .then((result) => {
        localStorage.setItem("token", result.accessToken);
        setSkip(false);
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError && inProgress === InteractionStatus.None) {
          // Silent renewal failed — redirect once to re-authenticate.
          instance.acquireTokenRedirect({
            scopes: protectedResources.api.scopes.read,
            account,
            redirectUri: "/",
          });
        }
      });
  }, [instance, inProgress]);

  return {
    skip,
    setSkip,
  };
};

export default useFetchWithMsal;